import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "./_helpers/auth.guard";

const routes: Routes = [
  { path: "", redirectTo: "redirect", pathMatch: "full" },
  {
    path: "redirect",
    loadComponent: () =>
      import("./redirect/redirect.component").then((m) => m.RedirectComponent),
  },
  {
    path: "sign",
    loadChildren: () =>
      import("./authentication/authentication.module").then(
        (m) => m.AuthenticationModule,
      ),
  },
  {
    path: "app",
    loadChildren: () => import("./home/home.module").then((m) => m.HomeModule),
    canActivate: [AuthGuard],
  },
  // otherwise redirect to home
  { path: "**", redirectTo: "" },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      preloadingStrategy: PreloadAllModules, // remove this to test bundles on
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
